import parse from 'html-react-parser';
import styles from './cardLC.module.scss';
import EmailCapture from '../emailCapture/emailCapture';

export default function CardLC({
  brandImage,
  title,
  description,
  endNotes,
  emailCapture,
}) {
  return (
    <div className={styles.cardWrapper}>
      <img
        className={styles.lcLogo}
        data-testid={`${brandImage}-icon`}
        src={brandImage.url}
        alt={brandImage.alt}
        loading="lazy"
      />
      <div>
        <div className={styles.title}>
          <p>{parse(title)}</p>
        </div>
      </div>
      {description && (
        <div className={styles.description}>{parse(description)}</div>
      )}
      <EmailCapture {...emailCapture} />
      <div className={styles.endNotes}>{parse(endNotes)}</div>
    </div>
  );
}
